import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "size", "style", "use"];
import I18n from 'I18n';
import { uniqueId } from '../../utils/underscore';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';
import { BASE_ICON_SPACING_X } from 'HubStyleTokens/sizes';
import { OZ, CANDY_APPLE } from 'HubStyleTokens/colors';
import { emCalc } from '../../core/Style';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getLabel = use => {
  if (use === 'decrease') return I18n.text('salesUI.UIChangeArrow.decrease');
  if (use === 'increase') return I18n.text('salesUI.UIChangeArrow.increase');
  return null;
};
const ChangeArrow = styled.svg.withConfig({
  displayName: "UIChangeArrow__ChangeArrow",
  componentId: "sc-1hpb5xl-0"
})(["font-size:16px;height:0.625em;margin-right:", ";width:0.875em;color:", ";transform:", ";"], emCalc(BASE_ICON_SPACING_X), ({
  use
}) => use === 'increase' ? OZ : CANDY_APPLE, ({
  use
}) => use === 'decrease' && 'rotate(180deg)');
const ChangeArrowShape = styled.path.withConfig({
  displayName: "UIChangeArrow__ChangeArrowShape",
  componentId: "sc-1hpb5xl-1"
})(["fill:currentColor;"]);
class UIChangeArrow extends PureComponent {
  constructor(props) {
    super(props);
    this._id = uniqueId('change-arrow-');
  }
  render() {
    const _this$props = this.props,
      {
        color,
        size,
        style,
        use
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsxs(ChangeArrow, Object.assign({}, rest, {
      "aria-labelledby": this._id,
      role: "img",
      style: Object.assign({
        color,
        fontSize: size
      }, style),
      use: use,
      viewBox: "0 0 14 10",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("title", {
        id: this._id,
        children: getLabel(use)
      }), /*#__PURE__*/_jsx(ChangeArrowShape, {
        d: "M0 9.63h14L7 0",
        fillRule: "evenodd"
      })]
    }));
  }
}
UIChangeArrow.displayName = 'UIChangeArrow';
UIChangeArrow.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  use: PropTypes.oneOf(['increase', 'decrease']).isRequired
};
export default UIChangeArrow;